<template>
  <div class="filter-select">
    <span class="filter-select__label"><label class="filter-select__text" :for="selectId">{{ label }}</label><slot name="info"></slot></span>
    <select :id="selectId" class="form-control" :value="value" :disabled="disabled" @change="$emit('input', $event.target.value)">
      <option value="">{{ allLabel }}</option>
      <option v-for="option in options" :key="option.value" :value="String(option.value)">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
let sequence = 0;

/**
 * Filtro de escolha unica para a filter-bar. Valor sempre texto (vem da URL);
 * vazio = "Todos", sem filtro.
 */
export default {
  name: 'filter-select',
  props: {
    label: { type: String, required: true },
    value: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    allLabel: { type: String, default: 'Todos' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    sequence += 1;
    return { selectId: 'filter-select-' + sequence };
  },
};
</script>

<style scoped>
.filter-select { display: block; margin: 0; font-weight: 400; }
.filter-select__label { display: block; margin-bottom: 4px; font-size: 12px; color: #4e5560; }
.filter-select__text { display: inline; max-width: none; margin: 0; font-size: inherit; font-weight: inherit; color: inherit; }
.filter-select .form-control { width: 170px; height: 34px; font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/filterSelect.vue